<template>
  <div id="sshet-basic-details">
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <hr class="hr-text" data-content="Details"/>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="sd-bd-property" class="form-label">Property</label>
              <select class="form-control" id="sd-bd-property" v-model="entity.property">
                <option value=""></option>
                <option v-for="opt in properties" :value="opt">{{ opt }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="sd-data-type" class="form-label">Data Type</label>
              <select class="form-control" id="sd-data-type" v-model="entity.dataType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SPREADSHEET_DATA_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group" v-show="isActualValue">
              <label for="sd-actual" class="form-label">Actual Value</label>
              <select v-if="useDropdownActualValue" class="form-control" id="sd-actual" v-model="entity.actualValue">
                <option value=""></option>
                <option v-for="(opt, i) in actualValueOptions" :value="opt.code">{{ opt.name }}</option>
              </select>
              <input v-else type="text" class="form-control" id="sd-actual" v-model="entity.actualValue"/>
            </div>
            <div v-show="!isActualValue">
              <div class="form-group">
                <label for="sd-tab" class="form-label">Name</label>
                <input type="text" class="form-control" id="sd-tab" v-model="entity.name"/>
              </div>
              <div class="form-group">
                <label for="sd-cell" class="form-label">Cell</label>
                <input type="text" class="form-control" id="sd-cell" v-model="entity.cell"/>
              </div>
              <div class="form-group">
                <label for="sd-tabname" class="form-label">Tab Name</label>
                <input type="text" class="form-control" id="sd-tabname" v-model="entity.tabName"/>
              </div>
              <div class="form-group">
                <label for="sd-mask" class="form-label">Mask</label>
                <input type="text" class="form-control" id="sd-mask" v-model="entity.mask"/>
              </div>
              <div class="form-group">
                <label for="sd-rep" class="form-label">Repeating</label>
                <input type="text" class="form-control" id="sd-rep" v-model="entity.repeating"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div v-show="!isActualValue">
              <div class="form-group">
                <label for="sd-s-column" class="form-label">Start Column</label>
                <input type="text" class="form-control" id="sd-s-column" v-model="entity.startColumn"/>
              </div>
              <div class="form-group">
                <label for="sd-sr" class="form-label">Start Row</label>
                <input type="text" class="form-control" id="sd-sr" v-model="entity.startRow"/>
              </div>
              <div class="form-group">
                <label for="sd-e-column" class="form-label">End Column</label>
                <input type="text" class="form-control" id="sd-e-column" v-model="entity.endColumn"/>
              </div>
              <div class="form-group">
                <label for="sd-er" class="form-label">End Row</label>
                <input type="text" class="form-control" id="sd-er" v-model="entity.endRow"/>
              </div>
              <div class="form-group">
                <label for="sd-off" class="form-label">Offset</label>
                <input type="text" class="form-control" id="sd-off" v-model="entity.offset"/>
              </div>
              <div class="form-group">
                <label for="skipRows" class="form-label">Skip rows?</label>
                <div class="material-switch">
                  <input id="skipRows" type="checkbox" v-model="entity.skipRows"/>
                  <label for="skipRows" class="label-success"></label>
                </div>
              </div>
              <div class="form-group">
                <label for="sd-continuousNoOfRows" class="form-label">Continuous No. Of Rows</label>
                <input type="text" class="form-control" id="sd-continuousNoOfRows" v-model="entity.continuousNoOfRows"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div v-if="entity.id" class="btn btn-warning" @click="doClear">
                Add
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <vue-table
              :tableData="details"
              tableTitle="Details"
              v-on:table-edit-request="updateActive"
              :showEdit="true"
              v-on:table-delete-request="doDelete"
              :showDelete="true"
              :fields="fields"
            ></vue-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import HelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import SheetMixin from './SheetMixin'
  export default {
    name: 'SpreadSheetBasicDetails',
    mixins: [ HelperMixin, SheetMixin ],
    components: {
      VueTable
    },
    props: [ 'dets', 'parent', 'entityType', 'properties' ],
    data () {
      return {
        fields: [
          { header: 'Property', prop: 'property' },
          { header: 'Type', prop: item => this.getDataType(item.dataType) },
          { header: 'Value', prop: 'actualValue' },
          { header: 'Cell', prop: 'cell' },
          { header: 'Start Column', prop: 'startColumn' },
          { header: 'Start Row', prop: 'startRow' },
          { header: 'End Column', prop: 'endColumn' },
          { header: 'End Row', prop: 'endRow' },
          { header: 'Mask', prop: 'mask' },
          { header: 'Column Offset', prop: 'offset' }
        ],
        details: [],
        entity: {
          id: null,
          dataType: null,
          property: null,
          name: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          entityType: this.entityType || this.sheetDescDetail,
          actualValue: null,
          parent: null,
          mask: null,
          offset: null,
          repeating: null,
          skipRows: 0,
          continuousNoOfRows: null
        },
        updateClicked: false,
        lineDropdownProperties: [
          'container',
          'wood',
          'transittype',
          'distancetype'
        ],
        additionDropdownProperties: [
          'nominalcode',
          'rateper',
          'adviceonly'
        ],
        noteDropdownProperties: [
          'subjectchoice'
        ]
      }
    },
    watch: {
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          // this.$emit('updating', newVal)
        }
      },
      dets: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.details)) {
            this.details = newVal
          }
        }
      },
      'entity.actualValue' (newVal, oldVal) {
        if (this.entity.property === 'nominalcode') {
          if (newVal && newVal.indexOf('::') > 0) {
            this.entity.actualValue = newVal.substring(newVal.indexOf('::') + 2)
          }
        }
      }
    },
    computed: {
      saveOrUpdate () {
        return this.entity.id !== null ? 'Update' : 'Save'
      },
      saveMethod () {
        return this.entity.id !== null ? 'put' : 'post'
      },
      saveUrl () {
        return this.entity.id ? API.UPDATE_ADMIN_ENTITY('spreadsheet-descriptor', this.entity.id) : API.CREATE_ADMIN_ENTITY('spreadsheet-descriptor')
      },
      isActualValue () {
        return this.getDataType(this.entity.dataType) === 'Actual Value'
      },
      useDropdownActualValue () {
        if (this.entityType === this.sheetDescNoteField) {
          return this.noteDropdownProperties.includes(this.entity.property)
        } else if (this.entityType === this.sheetDescAdditionField) {
          return this.additionDropdownProperties.includes(this.entity.property)
        } else {
          return this.lineDropdownProperties.includes(this.entity.property)
        }
      },
      actualValueOptions () {
        if (this.entity.property === 'container') {
          return this.getSystemOptions('CONTAINER_TYPE')
        } else if (this.entity.property === 'wood') {
          return this.getSystemOptions('WOOD_LOOSE')
        } else if (this.entity.property === 'transittype') {
          return [
            { code: 'H', name: 'Hour' },
            { code: 'D', name: 'Day' }
          ]
        } else if (this.entity.property === 'distancetype') {
          return this.getSystemOptions('DISTANCE_TYPE')
        } else if (this.entity.property === 'nominalcode') {
          return this.getFinancialCodes()
        } else if (this.entity.property === 'rateper') {
          return this.getSystemOptions('BREAKPOINT_UNIT')
        } else if (this.entity.property === 'adviceonly') {
          return [
            { code: 'Yes', name: 'Yes' },
            { code: 'No', name: 'No' }
          ]
        } else if (this.entity.property === 'subjectchoice') {
          return this.getSystemOptions('NOTE_SUBJECT')
        }
        return null
      }
    },
    methods: {
      updateActive ({ item, index }) {
        for (let prop in item) {
          this.entity[prop] = item[prop]
        }
      },
      getDataType (id) {
        if (id !== null) {
          let o = this.getSystemOption(id)
          return o && o.hasOwnProperty('name') ? o.name : ''
        }
        return ''
      },
      save () {
        if (!this.updateClicked) {
          this.updateClicked = true
          this.$http[this.saveMethod](this.saveUrl, { ...this.entity, entityType: this.entityType || this.sheetDescDetail, parent: this.parent })
          .then(({data}) => {
            if (data.hasOwnProperty('id')) {
              this.entity.id = data.id
              this.addToList({ ...this.entity })
              event.$emit('toast', { type: 'success', message: 'Saved successfully' })
            }
          }).catch(err => {
            event.$emit('toast', { type: 'error', message: err.message })
            console.log(err)
          }).then(() => {
            this.updateClicked = false
          })
        }
      },
      addToList (de) {
        let i = this.details.findIndex(d => d.id === de.id)
        if (i === -1) {
          this.details.push(de)
        } else {
          for (let prop in de) {
            this.details[i][prop] = de[prop]
          }
        }
        this.doClear()
      },
      doClear () {
        this.$nextTick(() => this.updateActive({ item: this.getBaseData(), index: null }))
      },
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('spreadsheet-descriptor', item.id))
        .then(res => {
          let i = this.details.findIndex(({id}) => id === item.id)
          if (i > -1) {
            this.details.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Item Deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      getBaseData () {
        return {
          id: null,
          dataType: null,
          property: null,
          name: null,
          tabName: null,
          cell: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          actualValue: null,
          entityType: this.entityType || this.sheetDescDetail,
          mask: null,
          offset: null,
          repeating: null,
          skipRows: 0,
          continuousNoOfRows: null
        }
      },
      getFinancialCodes () {
        let results = []
        const financialCodes = this.$store.getters['systemOption/financialCodes'].sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
        financialCodes.forEach(fc => results.push({code: fc.name, name: fc.name}))
        return results
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/modules/admin/components/SpreadsheetDescriptor/Lines.vue